export namespace ERROR_MESSAGES {
  export const LOAD_APPLICATION_LIST_ERROR =
    "There was a problem trying to load the applications list";
  export const LOAD_DECLINED_TRANSACTIONS_LIST_ERROR =
    "There was a problem trying to load the declined transactions list";
  export const LOAD_DECLINED_TRANSACTIONS_DETAIL_ERROR =
  "There was a problem trying to load the transaction detail";
  export const LOAD_MY_APPLICATION_LIST_ERROR =
    "There was a problem trying to load the my applications list";
  export const LOAD_DRAFT_LIST_ERROR =
    "There was a problem trying to load the drafts list";
  export const UPDATE_APPLICATION_ERROR =
    "There was a problem trying to update the application data.";
  export const CHANGE_CREDIT_LIMIT_ERROR =
    "There was a problem trying to update the credit limit.";
  export const CANCEL_APPLICATION_ERROR =
    "There was a problem trying to cancel the application.";
  export const DECLINE_CALLBACK_OUTCOME_ERROR =
    "There was a problem trying to decline the application.";
  export const CREDIT_TEAM_DECLINE_APPLICATION_ERROR =
    "There was a problem trying to decline the application.";
  export const CREDIT_TEAM_APPROVE_APPLICATION_ERROR =
    "There was a problem trying to approve the application.";
  export const CREDIT_TEAM_NEED_PG_ERROR =
    "There was a problem trying to approve the application.";
  export const LOAD_APPLICATION_ERROR =
    "There was a problem trying to load the application data.";
  export const COMPLETED_APPLICATION_ERROR =
    "There was a problem trying to complete the application.";
  export const CREATE_PROMO_OFFER_ERROR =
    "There was a problem trying to create the promo code. Please try again later.";
  export const UPDATE_PROMO_OFFER_ERROR =
    "There was a problem trying to save the promo code. Please try again later.";
  export const LOAD_PROMO_OFFER_BY_OFFER_ID_ERROR =
    "There was a problem trying to load the offer details. Please try again later.";
  export const LOAD_PROMO_OFFER_LIST_ERROR =
    "There was a problem trying to load the offers. Please try again later.";
  export const LOAD_PROMO_OFFER_ERROR =
    "There was a problem trying to load the offer details. Please try again later.";
  export const FETCH_REFERENCE_DATA_ERROR =
    "There was a problem trying to load the reference data. Please try again later.";
  export const UPDATE_REFERENCE_DATA_ERROR =
    "There was a problem trying to update the reference data. Please try again later.";
  export const FETCH_BANK_DATA_ERROR =
    "There was a problem trying to load the banks reference data.";
  export const LOAD_STANDARD_OFFER_BY_OFFER_ID_ERROR =
    "There was a problem trying to load the offer details. Please try again later.";
  export const CREATE_STANDARD_OFFER_ERROR =
    "There was a problem trying to create the standard offer. Please try again later.";
  export const UPDATE_STANDARD_OFFER_ERROR =
    "There was a problem trying to save the offer details. Please try again later.";
  export const LOAD_STANDARD_OFFER_ERROR =
    "There was a problem trying to load the offer details. Please try again later.";
  export const LOAD_STANDARD_OFFERS_LIST_ERROR =
    "There was a problem trying to load the offers. Please try again later.";
  export const LOAD_APPLICATION_TIMELINE_ERROR =
    "There was a problem trying to load the application timeline.";
  export const ASSIGN_TASK_ERROR =
    "There was a problem trying to assign the task. Please try again later.";
  export const UNASSIGN_TASK_ERROR =
    "There was a problem trying to unassign the task. Please try again later.";
  export const UPDATE_TASK_ERROR =
    "There was a problem trying to update the task";
}
